
const validate = values => {

  const errors = {}

  if (!values.title) {
    errors.title = 'Title is required';
  }

  if (!values.description) {
    errors.description = 'Description is required';
  }

  if (!values.buttonLabel) {
    errors.buttonLabel = 'Button Label is required';
  }

  return errors
}

export default validate
